var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "modal",
    {
      attrs: { title: "Build a tracking link", "show-footer": false },
      on: {
        close: function($event) {
          return _vm.$emit("close")
        }
      }
    },
    [
      _c("div", { staticClass: "utm-layout" }, [
        _c("div", { staticClass: "utm-questions" }, [
          _c("div", { staticClass: "form-group" }, [
            _c("label", { attrs: { for: "utm-source" } }, [
              _vm._v("Who is sharing this link?")
            ]),
            _c("input", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model.trim",
                  value: _vm.source,
                  expression: "source",
                  modifiers: { trim: true }
                }
              ],
              ref: "sourceInput",
              staticClass: "form-control",
              attrs: {
                id: "utm-source",
                type: "text",
                placeholder: "A person's name, a company, a partner ..."
              },
              domProps: { value: _vm.source },
              on: {
                input: function($event) {
                  if ($event.target.composing) {
                    return
                  }
                  _vm.source = $event.target.value.trim()
                },
                blur: function($event) {
                  return _vm.$forceUpdate()
                }
              }
            })
          ]),
          _c("div", { staticClass: "form-group" }, [
            _c("label", { attrs: { for: "utm-medium" } }, [
              _vm._v("Where will it be shared?")
            ]),
            _c(
              "select",
              {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.selectedMediumValue,
                    expression: "selectedMediumValue"
                  }
                ],
                staticClass: "form-control",
                attrs: { id: "utm-medium" },
                on: {
                  change: function($event) {
                    var $$selectedVal = Array.prototype.filter
                      .call($event.target.options, function(o) {
                        return o.selected
                      })
                      .map(function(o) {
                        var val = "_value" in o ? o._value : o.value
                        return val
                      })
                    _vm.selectedMediumValue = $event.target.multiple
                      ? $$selectedVal
                      : $$selectedVal[0]
                  }
                }
              },
              [
                _c("option", { attrs: { value: "" } }, [
                  _vm._v("Pick where it will be shared")
                ]),
                _vm._l(_vm.mediumGroups, function(group) {
                  return _c(
                    "optgroup",
                    { key: group.group, attrs: { label: group.group } },
                    _vm._l(group.options, function(opt) {
                      return _c(
                        "option",
                        { key: opt.value, domProps: { value: opt.value } },
                        [_vm._v(" " + _vm._s(opt.label) + " ")]
                      )
                    }),
                    0
                  )
                })
              ],
              2
            ),
            _vm.mediumHint
              ? _c("div", { staticClass: "utm-hint" }, [
                  _c("i", { staticClass: "fa fa-info-circle" }),
                  _vm._v(" " + _vm._s(_vm.mediumHint) + " ")
                ])
              : _vm._e(),
            _vm.isOtherMedium
              ? _c("div", { staticClass: "utm-other" }, [
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model.trim",
                        value: _vm.otherMedium,
                        expression: "otherMedium",
                        modifiers: { trim: true }
                      }
                    ],
                    staticClass: "form-control",
                    attrs: {
                      id: "utm-medium-other",
                      type: "text",
                      placeholder: "Describe it in one word, eg webinar"
                    },
                    domProps: { value: _vm.otherMedium },
                    on: {
                      input: function($event) {
                        if ($event.target.composing) {
                          return
                        }
                        _vm.otherMedium = $event.target.value.trim()
                      },
                      blur: function($event) {
                        return _vm.$forceUpdate()
                      }
                    }
                  })
                ])
              : _vm._e()
          ]),
          _c("div", { staticClass: "form-group" }, [
            _c("label", { attrs: { for: "utm-content" } }, [
              _vm._v("Anywhere more specific? (optional)")
            ]),
            _c("input", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model.trim",
                  value: _vm.content,
                  expression: "content",
                  modifiers: { trim: true }
                }
              ],
              staticClass: "form-control",
              attrs: {
                id: "utm-content",
                type: "text",
                placeholder: _vm.contentPlaceholder
              },
              domProps: { value: _vm.content },
              on: {
                input: function($event) {
                  if ($event.target.composing) {
                    return
                  }
                  _vm.content = $event.target.value.trim()
                },
                blur: function($event) {
                  return _vm.$forceUpdate()
                }
              }
            })
          ])
        ]),
        _c("div", { staticClass: "utm-result" }, [
          _c("div", { staticClass: "utm-result__header" }, [
            _vm._v("Your tracking link")
          ]),
          _c("div", { staticClass: "utm-result__body" }, [
            _c("div", { staticClass: "utm-result__url-row" }, [
              _c(
                "div",
                { staticClass: "utm-preview" },
                [
                  _c("span", [
                    _vm._v(
                      _vm._s(_vm.baseUrl) +
                        "?utm_campaign=" +
                        _vm._s(_vm.encodedCampaign)
                    )
                  ]),
                  _vm._l(_vm.dynamicParts, function(part) {
                    return [
                      part.value
                        ? [
                            _c("span", { key: part.key }, [
                              _vm._v("&" + _vm._s(part.param) + "=")
                            ]),
                            _c(
                              "span",
                              {
                                key: part.key + "-val",
                                staticClass: "utm-value"
                              },
                              [_vm._v(_vm._s(_vm.encodeParam(part.value)))]
                            )
                          ]
                        : !part.optional
                        ? [
                            _c("span", { key: part.key }, [
                              _vm._v("&" + _vm._s(part.param) + "=")
                            ]),
                            _c(
                              "span",
                              {
                                key: part.key + "-ph",
                                staticClass: "utm-placeholder"
                              },
                              [_vm._v(_vm._s(part.placeholderLabel))]
                            )
                          ]
                        : _vm._e()
                    ]
                  })
                ],
                2
              ),
              _c(
                "button",
                {
                  staticClass: "btn btn-primary utm-copy-btn",
                  attrs: { type: "button", disabled: !_vm.isComplete },
                  on: { click: _vm.copyLink }
                },
                [
                  _c("i", {
                    staticClass: "fa",
                    class: _vm.copied ? "fa-check" : "fa-clipboard"
                  }),
                  _vm._v(" " + _vm._s(_vm.copied ? "Copied" : "Copy") + " ")
                ]
              )
            ]),
            _c("hr", { staticClass: "utm-result__divider" }),
            !_vm.isComplete
              ? _c("p", { staticClass: "utm-incomplete" }, [
                  _c("i", { staticClass: "fa fa-info-circle" }),
                  _vm._v(" Fill in "),
                  _c("strong", [_vm._v("who is sharing")]),
                  _vm._v(" and "),
                  _c("strong", [_vm._v("where")]),
                  _vm._v(" to finish your link and create its QR code. ")
                ])
              : _c(
                  "div",
                  { staticClass: "utm-result__qr" },
                  [
                    _c("qrcode", {
                      ref: "qrcode",
                      staticClass: "utm-qrcode-img",
                      attrs: {
                        value: _vm.finalUrl,
                        options: {
                          width: 150,
                          margin: 1,
                          errorCorrectionLevel: "L"
                        }
                      }
                    }),
                    _c("div", { staticClass: "utm-result__qr-text" }, [
                      _c("div", { staticClass: "utm-result__qr-title" }, [
                        _vm._v("QR code")
                      ]),
                      _c("p", { staticClass: "utm-result__qr-hint" }, [
                        _vm._v("Copy or download to share this link.")
                      ]),
                      _c("div", { staticClass: "utm-qr-actions" }, [
                        _c(
                          "button",
                          {
                            staticClass: "btn btn-default btn-sm",
                            attrs: { type: "button" },
                            on: { click: _vm.copyQr }
                          },
                          [
                            _c("i", {
                              staticClass: "fa",
                              class: _vm.qrCopied ? "fa-check" : "fa-clipboard"
                            }),
                            _vm._v(
                              " " +
                                _vm._s(_vm.qrCopied ? "Copied" : "Copy QR") +
                                " "
                            )
                          ]
                        ),
                        _c(
                          "button",
                          {
                            staticClass: "btn btn-default btn-sm",
                            attrs: { type: "button" },
                            on: { click: _vm.downloadQr }
                          },
                          [
                            _c("i", { staticClass: "fa fa-download" }),
                            _vm._v(" Download QR ")
                          ]
                        )
                      ])
                    ])
                  ],
                  1
                )
          ])
        ])
      ])
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }